<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Olr9hd/tc-custom/9781609455705.jpg?1725275644524" alt="This image is the cover for the book Blues for Outlaw Hearts and Old Whores, The Alligator Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blues for Outlaw Hearts and Old Whores, The Alligator Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>This Alligator mystery, “a simple gangster revenge tale . . . gets more and more emotionally intense . . . Crime writing this good just has to be read” (NB Magazine).</b><br/><br/>International secret police operations, drug trafficking, prostitution, and identity theft set the stage for the eternal struggle between Good and Evil.<br/><br/>Acclaimed as one of today’s best contemporary noir writers, Massimo Carlotto reaches new heights in the most complex “Alligator” novel to date. Rich with biting humor, humanity, and psychological insight, this is an exemplary noir novel from a crime writer at the top of his game.<br/><br/>Marco Buratti, a.k.a. the Alligator, and his partners Max the Memory and Beniamino Rossini have fallen into a trap laid by their worst enemy, Giorgio Pellegrini, a wanted man who has no intention of living as a fugitive for the rest of his life and turns state evidence, but something goes wrong. Blackmailed by a high government official, the Alligator and his partners are forced to investigate. But they’ve been framed: even if they discover who’s behind the crime, they’ll rot in prison. To survive, some rules will have to be bent, and others broken.<br/><br/><b>“Gripping . . . James Ellroy fans will be satisfied.” —Publishers Weekly</b><br/><br/><b>“A masterpiece . . . Blues for Outlaw Hearts and Old Whores is Carlotto writing in top form.” —Mystery Tribune</b><br/><br/><b>“Carlotto’s novels are perfectly balanced, everything moves in the right, often unexpected direction. Sudden turns of events are interspersed with dialogue that reminds of postwar American noir films . . . Somewhere up there Raymond Chandler is surely applauding.” —<i>La Stampa</i></b><br/><br/><b>“A fine read, with good writing and flashes of oblique humor.” —Booklist</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Massimo Carlotto, Will Schutt
      </h2>
      
      <p class="authorDescription body article"><P><B>Massimo Carlotto</B> was born in Padua, Italy. In addition to the many titles in his extremely popular “Alligator” series, he is also the author of <I>The Fugitive</I>, <I>Death’s Dark Abyss</I>, <I>Poisonville</I>, <I>Bandit Love</I>, and <I>At the End of a Dull Day</I>. He is one of Italy’s most popular authors and a major exponent of the Mediterranean Noir novel.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Europa Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2e4ab122